import { RewardCardAccountStatus, RewardCardStatus } from '@/constants/rewardCard';

export interface OperationsLog {
  attempts: number;
  completed_at: string | null;
  errors: Record<number, string> | null; // { attempt_number: error string }
  id: string;
  last_attempt_at: string | null;
  manual_retry_allowed: boolean;
  operation_type: string;
  person_id: string;
  pex_resource_id: number;
  pex_resource_type: string;
  request_sent_at: string;
}

export interface CardOrder {
  card_order_id: string | null;
  fail_reason: string | null;
  id: string;
  ordered_at: string;
  status: string;
}

export interface RewardCard {
  card_id: string;
  card_status: RewardCardStatus;
  expiration_date: string;
  issued_date: string;
  last_4_card_number: string;
  pex_card_id: number;
  activated_at: string | null;
}

export interface RewardCardAccount {
  account_id: string;
  account_status: RewardCardAccountStatus;
  available_balance_in_cents: number; // (Available balance for the card account in cents)
  balance_forwarded_in_cents: number | null;
  balance_forwarded_to_account_id: string | null;
  billing_address: AccountAddress | null;
  closing_balance_in_cents: number | null;
  current_card: RewardCard | null;
  date_of_birth: string;
  email: string;
  id: string;
  is_virtual: boolean;
  ledger_balance_in_cents: number; // (Ledger balance for the card account in cents)
  order: CardOrder | null;
  person_id: string;
  pex_account_id: number; // (Unique cardholder account id)
  phone: string;
  shipping_address: AccountAddress | null;
  shipping_phone: string;
  will_terminate_at: string | null;
}

export interface AccountAddress {
  account_address_id: string;
  address1: string;
  address2: string;
  city: string;
  company: string;
  country: string;
  delivery_point_barcode?: string | null;
  dpv_match_code?: string | null;
  first_name: string;
  last_name: string;
  mailing_instructions: string | null;
  postal_code: string;
  state: string;
}

export interface Transaction {
  card_account_id: string;
  has_receipt: boolean | null;
  hold_at: string | null;
  id: string;
  internal_type: InternalType;
  is_decline: boolean;
  is_pending: boolean;
  mcc_code: string | null;
  merchant_icon_url: string | null;
  merchant_local_time_at: string | null;
  merchant_logo_url: string | null;
  merchant_name: string | null;
  message: string | null;
  padding_amount_in_cents: number;
  settlement_at: string | null;
  transaction_amount_in_cents: number;
  transaction_at: string;
  transaction_day: string; // standard datetime format of the zeroith hour of the date of the transaction in the timezone of the merchant
  transaction_id: string;
  transaction_notes: object | null;
  transaction_type: string;
  transaction_type_category: string;
}

export enum InternalType {
  ACCOUNT_FUND = 'account_fund',
  BALANCE_ADJUSTMENT = 'balance_adjustment',
  DEBIT = 'debit',
  DECLINE = 'decline',
  FORWARD_CREDIT = 'forward_credit',
  FORWARD_DEBIT = 'forward_debit',
  REFUND = 'refund'
}
